import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

export const Carousel = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 16px 0 48px;
`;

export const Container = styled.div`
  display: -webkit-box;
  transition: ${({ useTransition }: { useTransition?: boolean }) => (useTransition ? 'all 400ms ease-in-out' : 'none')};
`;

export const CarouselItem = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;

  ${mediaMixin(
    'md',
    css`
      padding: 0 100px;
    `,
  )};
`;

export const Prev = styled.div`
  position: absolute;
  top: 50%;
  left: 16px;
  padding: 16px;
  cursor: pointer;
  transform: translateY(-50%);
`;

export const Next = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  padding: 16px;
  cursor: pointer;
  transform: translateY(-50%);
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
`;
